import React, { useState } from 'react'
import { isUkPostcode } from '@sainsburys-tech/bolt-validators'
import { Input } from '@sainsburys-tech/bolt'
import collectionMessaging from '../../../config/fulfilment-collection-messaging.json'

const getErrorMessage = (validPostcode, deliveryError, stockCheckAvailable) => {
  if (!validPostcode) return 'Please enter a valid postcode'
  if (deliveryError && validPostcode) return deliveryError
  if (!stockCheckAvailable) return collectionMessaging.STOCK_CHECK_FAIL
  return ''
}

const displaySearchStock = (deliveryLoading, deliveryMessage, showDeliveryForm, deliverable) =>
  (!deliveryLoading && deliveryMessage && showDeliveryForm) ||
  (!deliveryLoading && deliverable && !deliveryMessage && showDeliveryForm)

export const DeliveryForm = ({
  showDeliveryForm,
  deliverySearchTerm,
  updateDeliverySearchTerm,
  findButtonText,
  searchDelivery,
  deliveryProps,
  updateIsInitialMount,
  deliverable
}) => {
  const [validPostcode, setValidPostcode] = useState(true)
  const dataTest = 'fulfilment-search-stock'
  const addPostCodeMessage = 'Enter Postcode:'

  const {
    storeLocator: { deliveryError, stockCheckAvailable, deliveryLoading, deliveryMessage }
  } = deliveryProps

  const localSearchDelivery = event => {
    event.preventDefault()
    if (!isUkPostcode(deliverySearchTerm.trim())) {
      setValidPostcode(false)
    } else {
      const userCd = true // indicates user chose new delivery postcode for analytics
      setValidPostcode(true)
      searchDelivery(deliveryProps, deliverySearchTerm, updateIsInitialMount, userCd)
    }
  }

  return (
    displaySearchStock(deliveryLoading, deliveryMessage, showDeliveryForm, deliverable) && (
      <form onSubmit={localSearchDelivery} data-test={`${dataTest}-form`}>
        <Input
          type='text'
          aria-label='Search Stock'
          value={deliverySearchTerm}
          onChange={updateDeliverySearchTerm}
          placeholder={addPostCodeMessage}
          name='search'
          autoComplete='off'
          error={getErrorMessage(validPostcode, deliveryError, stockCheckAvailable)}
          data-test={`${dataTest}-search-input`}
          buttonOptions={{
            text: findButtonText,
            type: 'submit',
            show: true,
            kind: 'secondary',
            'data-test': `${dataTest}-search-button`
          }}
          onKeyPress={event => {
            if (event.key === 'Enter') {
              localSearchDelivery(event)
            }
          }}
        />
      </form>
    )
  )
}
